module.exports = __webpack_public_path__ + "img/education_assist_icon.5c0a9bda.svg";